import React, { forwardRef } from 'react'
import { useId } from '../../../hooks'

export const Input = forwardRef(
  ({ label, error, errorMessage, id, className, ...rest }, ref) => {
    const _id = useId('dev_dash')
    const inputId = id ? id : _id

    const inputClassName = ['dev_dash__input', className ? className : '']
      .join(' ')
      .trim()

    return (
      <>
        <label className="sr-only" htmlFor={inputId}>
          {label ? label : inputId}
        </label>
        <input
          id={inputId}
          ref={ref}
          data-invalid={error}
          className={inputClassName}
          {...rest}
        />
        {error && errorMessage && (
          <span className="dev_dash__input--error_message">{errorMessage}</span>
        )}
      </>
    )
  },
)
